export default "__VITE_ASSET__Db99LFC4__"